var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



//////////////////
// WEBPACK FOOTER
// C:/Users/Administrator/submit text project/gwin/~/._core-js@2.5.0@core-js/modules/_cof.js
// module id = ../../../../._core-js@2.5.0@core-js/modules/_cof.js
// module chunks = 2